import Slider from "react-slick";
import { getImages } from "../Common/const";
import { useRef } from "react";

const reviewsList = [
  {
    name: "Joshua Tanton",
    content:
      "I found a vehicle in amazing condition that I have been looking for, for a while. Finally found it. I gave Bobby a call. I informed I was interested and would be there the next day. I showed up saw the car and the pictures did not do this car justice whatsoever. It was in the exact condition, possibly better than advertised. He offered a test drive with zero hesitation. Price was amazingly fair for the condition, year and mileage. If I’m ever in the need for another luxury vehicle I will 100 percent be going back to Bobby! I will recommend anyone that I know to Bobby for all the fairness and transparency and great customer service that he and his wife provided! Thank you Bobby for my amazing ZO6!",
  },
  {
    name: "Rudy Rodriguez (MedPlan)",
    content:
      "Bought a 2022 F450 from Bobby, the car was perfect! Low miles and at a great price. Called him on a Sunday and by 1pm Monday I was picking up my truck. Tag was ready very easy transaction",
  },
  {
    name: "Aaron Taylor",
    content:
      "We recently purchased a used Audi TTS from Bobby, and I can confidently say it was the most seamless car-buying experience I’ve ever had. From start to finish, Bobby was incredibly patient, helpful, and professional. He walked us through the financing process, answered every question thoroughly, and was super responsive—even after hours. It’s clear he genuinely cares about his customers and goes the extra mile to make the process smooth and stress-free. I highly recommend Bobby to anyone in the market for a vehicle, and I’ll absolutely be returning to him for future purchases.",
  },
  {
    name: "Chris Ciocca",
    content:
      "After doing business with Mercedes Showroom a few times now, they are always my first stop. The quality of their handpicked vehicles are top of the line. Always well maintained, great options, and the best customer service. I am a true customer for life.",
  },
  {
    name: "Jose Pretel",
    content:
      "Huge thank you to Bobby at Mercedeshowroom for making my Hellcat purchase smooth and stress-free. From the start, he was honest, knowledgeable, and didn’t try to play any of the usual dealership games. He made sure I got exactly what I wanted and was super easy to work with the whole way through.",
  },
  {
    name: "Ray Vitiello",
    content:
      "We were out of the country when the exact car I was looking for popped up on Carfax. I contacted Kendall and sent a deposit, and they held the car for me. When I went to see it, it was exactly as described, in like-new condition. Bobby made the whole transaction easy. If you’re looking for an alternative to a huge Mercedes dealership, this mom & pop operation is a great choice. Highly recommended.",
  },
  {
    name: "Gianluca Esposito",
    content:
      "I recently had a fantastic experience at the Mercedes showroom. Bobby was exceptionally nice, always available, and very understanding throughout the entire process. He provided me with great service and made sure everything went smoothly. I got a wonderful price and am thoroughly enjoying my beautiful SL 450. I definitely recommend this showroom for their professional staff and high-quality vehicles. Great people and top-notch service!",
  },
  {
    name: "Sasha Crisp",
    content:
      "Great experience picking up our 2014 Ferrari California. The condition was better than expected and Bobby went out of his way to get us the second key and owner’s manuals that were missing. Plus, no hassle or pressure when we were working through the deal. Plus, the way they handle the paperwork was really impressive. It’s always risky buying from an independent dealer but I have no reservations highly recommending Mercedes Showroom. Their business model is the best.",
  },
];

const HomeReviews = () => {
  const sliderRef = useRef(null);
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 2,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <>
      <section className='reviews-wrap'>
        <div className='container'>
          <div className='d-md-flex align-items-center justify-content-between reviews-heading'>
            <h4 className='lg-title font-3em fw-500 mb-3 mb-md-0 wow reveal fadeInUp'>Customer Reviews</h4>
            <div className='d-flex align-items-center wow reveal fadeInUp'>
              <img className='g-icon me-md-4 me-3' src={getImages("icon-google-user.png")} alt="quote" />
              <div className='lg-title font-3em fw-500 wow reveal fadeInUp helveticaneue me-md-4 me-3 rating-count'>4.8</div>
              <div className='xs-title text-uppercase'>Google Reviews Rating</div>
            </div>
          </div>
          <div className='review-slider-block px-4 wow reveal fadeIn'>
            <Slider ref={sliderRef} {...settings} className='review-slider'>
              {reviewsList.map((review, index) => (
                <div className="review-item" key={index}>
                  <div className="review-box">
                    <div className="review-mnh">
                      <p className="clamp-4">
                        {review.content}
                      </p>
                    </div>
                    <div className="d-flex align-items-end justify-content-between mt-1">
                      <div>
                        <div className="mb-md-3 mb-2 d-flex align-items-center">
                          {[...Array(5)].map((_, i) => (
                            <img key={i} className="me-1" src={getImages("star.svg")} alt="star" />
                          ))}
                        </div>
                        <div className="reviewer-name">{review.name}</div>
                      </div>
                      <div>
                        <div className="quote-icon mb-2">
                          <img src={getImages("quote-shape.png")} alt="quote" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}

            </Slider>
          </div>
        </div>
      </section>
    </>
  )
}

export default HomeReviews